module.exports = "../img/Liniers-Horizontal.jpg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Liniers-Horizontal.jpg
// module id = 58
// module chunks = 0